import { isEmpty } from 'lodash/fp';

import { DataResponse, TimeUnitKey } from '../../../types';
import sortRecordsByTimeUnit from './sort-records-by-time-unit';

const sortDataResponseByTimeUnit = (
    dataResponse: DataResponse,
    timeUnitKey: TimeUnitKey,
    shouldCastTimeUnitsToString?: boolean
): DataResponse => {
    if (isEmpty(dataResponse?.columns)) {
        return { columns: [], records: [] };
    }

    const { columns, records } = dataResponse;

    const sortedRecords = sortRecordsByTimeUnit(records, timeUnitKey, columns);

    if (shouldCastTimeUnitsToString) {
        const timeUnitKeyIdx = columns.indexOf(timeUnitKey);
        if (timeUnitKeyIdx !== -1) {
            sortedRecords.forEach((record) => {
                if (record[timeUnitKeyIdx] != null) {
                    record[timeUnitKeyIdx] = record[timeUnitKeyIdx].toString();
                }
            });
        }
    }

    return { columns, records: sortedRecords };
};

export default sortDataResponseByTimeUnit;
